import { Drawer } from 'antd';

/**
 * Drawer do antd para os detalhes à direita do módulo. Mesmo contorno do módulo Interoperabilidade:
 * o Drawer do antd 4.10 não tipa children com @types/react 18.
 */
const OcpiDrawer: any = Drawer;

/** Largura do detalhe da Interoperabilidade, para os dois módulos abrirem igual. */
export const DRAWER_WIDTH = 420;

export default OcpiDrawer;
